/*
  Komua : offres pilotées par les données (snippets komua-offers / komua-offers-cart, docs/offers/offers.json).
  Fiche produit ([data-komua-offers]) :
  - radio « single » : CTA Shrine natif inchangé (sauf si une case « ajout » est cochée) ;
  - radio quantité (data-quantity) : le panier contient au total N exemplaires de la variante choisie (pas de doublon) ;
  - radio pack (data-bundle-variant) : produit consulté + produit associé, chacun ajouté seulement s'il manque au panier ;
  - case ajout (data-addon-variant) : ajoutée en plus, seulement si absente du panier.
  Un clic réel sur le CTA principal ou la barre sticky ajoute toutes les lignes en une requête /cart/add.js, puis le tiroir
  Shrine est mis à jour (rendu de sections natif). Fiches du Pack Duo : si « Pack Duo » est choisi et qu'une case ajout
  est cochée, les deux produits du duo et l'ajout partent ensemble ; sinon le Pack Duo garde sa mécanique (komua-offer.js).
  Aucune remise calculée ici : les réductions automatiques Shopify s'appliquent au panier.
  Mesure : komua_offer_view, komua_offer_select, komua_offer_add_to_cart, komua_offer_completed (dataLayer + Shopify.analytics),
  avec placement (pdp, cart, homepage, collection, article) et campaign. Cartes d'offre (section komua-offer-cards) :
  komua_offer_card_view (carte vue à 50 %), komua_offer_card_click ; campagne : komua_campaign_view (barre, hero, cartes,
  recommandation du panier), komua_campaign_click.
  ?komua_offer=<offre>[:<quantité>] : présélectionne l'offre de la fiche (lien des cartes d'offre).
  Campagne terminée sur une page servie depuis un cache (data-komua-campaign-end, horodatage en secondes) : barre, hero et
  badges de la campagne sont masqués, la barre habituelle revient ; les offres elles-mêmes restent valables.
*/
(function () {
  if (window.komuaOffers) return;
  window.komuaOffers = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var json = { Accept: 'application/json' };

  // ── Mesure ──────────────────────────────────────────────────────────────────────────────────────────────────────────
  function track(name, data) {
    var payload = Object.assign({ event: 'komua_' + name }, data);
    try { (window.dataLayer = window.dataLayer || []).push(payload); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('komua_' + name, data); } catch (e) {}
  }
  function context(block) {
    return { product_id: Number(block.dataset.product), product_key: block.dataset.productKey, currency: block.dataset.currency, market: block.dataset.market, language: block.dataset.language, placement: 'pdp', campaign: block.dataset.campaign || '' };
  }
  function offerData(block, input) {
    return Object.assign(context(block), {
      offer_id: input.dataset.offer || 'single', offer_type: input.dataset.offerType || 'single',
      offer_quantity: Number(input.dataset.quantity || 1), offer_value: Number(input.dataset.value || 0) / 100
    });
  }

  // ── Panier et tiroir Shrine ─────────────────────────────────────────────────────────────────────────────────────────
  function drawer() { return document.querySelector('cart-drawer'); }
  function sectionIds(d) { return d && d.getSectionsToRender ? d.getSectionsToRender().map(function (s) { return s.id; }) : []; }
  function render(d, state) {
    if (!d || !d.renderContents) { window.location.href = root + 'cart'; return; }
    d.classList.remove('is-empty');
    d.renderContents(state);
  }
  function refresh(d) {
    if (!d) { window.location.href = root + 'cart'; return Promise.resolve(); }
    return fetch(root + '?sections=' + sectionIds(d).join(','), { headers: json })
      .then(function (r) { return r.json(); })
      .then(function (sections) { render(d, { sections: sections }); });
  }
  // lines : [{ id, quantity, product, mode }] ; mode « unique » = seulement si le produit manque, « target » = total visé
  // pour la variante, « add » = ajout simple.
  function addLines(lines) {
    var d = drawer();
    return fetch(root + 'cart.js', { headers: json })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var products = cart.items.map(function (i) { return i.product_id; });
        var items = [];
        lines.forEach(function (l) {
          if (!l.id) return;
          if (l.mode === 'unique') { if (products.indexOf(l.product) === -1) items.push({ id: l.id, quantity: 1 }); return; }
          if (l.mode === 'target') {
            var have = cart.items.filter(function (i) { return i.variant_id === l.id; }).reduce(function (s, i) { return s + i.quantity; }, 0);
            if (l.quantity - have > 0) items.push({ id: l.id, quantity: l.quantity - have });
            return;
          }
          items.push({ id: l.id, quantity: l.quantity || 1 });
        });
        if (!items.length) return refresh(d);
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items, sections: sectionIds(d), sections_url: window.location.pathname })
        })
          .then(function (r) { return r.json().then(function (body) { if (!r.ok || body.status) throw body; return body; }); })
          .then(function (state) { render(d, state); });
      });
  }

  // ── Fiche produit ───────────────────────────────────────────────────────────────────────────────────────────────────
  function selected(block) { return block.querySelector('input[type="radio"]:checked'); }
  function checkedAddons(block) { return [].slice.call(block.querySelectorAll('input[type="checkbox"][data-offer-type="addon"]:checked')); }
  function setLabel(btn, labelSel, priceSel, html, priceHtml) {
    var labelEl = btn.querySelector(labelSel);
    var priceEl = priceSel ? (priceSel.charAt(0) === '#' ? document.getElementById(priceSel.slice(1)) : btn.querySelector(priceSel)) : null;
    if (!btn.komuaOffersOriginal) btn.komuaOffersOriginal = { label: labelEl ? labelEl.innerHTML : null, price: priceEl ? priceEl.innerHTML : null, hidden: priceEl ? priceEl.classList.contains('hidden') : true };
    var o = btn.komuaOffersOriginal;
    if (labelEl) labelEl.innerHTML = html !== null ? html : o.label;
    if (priceEl) {
      if (priceHtml !== null) { priceEl.innerHTML = priceHtml; priceEl.classList.toggle('hidden', priceHtml === ''); }
      else if (o.price !== null) { priceEl.innerHTML = o.price; priceEl.classList.toggle('hidden', o.hidden); }
    }
  }
  function apply(block) {
    block.querySelectorAll('.komua-offers__option, .komua-offers__addon').forEach(function (el) {
      el.classList.toggle('is-selected', el.querySelector('input').checked);
    });
    // Sans sélecteur (fiches du Pack Duo : cases « ajout » seules), le CTA appartient au Pack Duo (komua-offer.js).
    if (!block.querySelector('input[type="radio"]')) return;
    var input = selected(block);
    var active = input && input.value !== 'single';
    var section = block.dataset.section;
    var main = document.getElementById('ProductSubmitButton-' + section);
    var sticky = document.getElementById('SectionAtcBtn-' + section);
    var cta = active && input.dataset.cta ? input.dataset.cta : null;
    var priceTpl = active ? input.parentElement.querySelector('template[data-cta-price]') : null;
    var stickyTpl = active ? input.parentElement.querySelector('template[data-sticky-price]') : null;
    if (main) { setLabel(main, '.main-atc__label__text', '.main-atc-price', cta, priceTpl ? priceTpl.innerHTML.trim() : null); main.toggleAttribute('data-komua-offers', !!active || checkedAddons(block).length > 0); }
    if (sticky) { setLabel(sticky, '.sticky-atc__label__text', '#sticky-atc-separate-price-' + section, cta, stickyTpl ? stickyTpl.innerHTML.trim() : null); sticky.toggleAttribute('data-komua-offers', !!active || checkedAddons(block).length > 0); }
  }
  function blockFor(btn) {
    var section = btn.id.replace(/^(ProductSubmitButton|SectionAtcBtn)-/, '');
    return document.querySelector('[data-komua-offers][data-section="' + section + '"]');
  }
  function formOf(btn) {
    var id = btn.getAttribute('form') || (btn.form && btn.form.id);
    return (id && document.getElementById(id)) || btn.form || null;
  }
  function showError(block, err) {
    var el = block.querySelector('.komua-offers__error');
    if (!el) return;
    el.textContent = (err && err.description) || block.dataset.error || '';
    el.hidden = false;
  }

  // Capture sur window : passe avant le gestionnaire du Pack Duo (document) et le formulaire Shrine.
  window.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('button[id^="ProductSubmitButton-"], button[id^="SectionAtcBtn-"]');
    if (!btn || !event.isTrusted || btn.disabled) return;
    var block = blockFor(btn);
    if (!block) return;
    var input = selected(block);
    var addons = checkedAddons(block);
    var offer = input && input.value !== 'single' ? input : null;
    var duo = btn.dataset.komuaOffer === 'duo';
    if (!offer && !addons.length) return; // achat simple ou Pack Duo seul : mécanique existante
    var form = formOf(btn);
    var variant = form && form.querySelector('[name="id"]');
    var variantId = variant ? Number(variant.value) : 0;
    var qtyInput = form && (document.querySelector('input[name="quantity"][form="' + form.id + '"]') || form.querySelector('input[name="quantity"]'));
    var qty = Math.max(1, Number(qtyInput && qtyInput.value) || 1);
    var product = Number(block.dataset.product);
    var lines = [];
    if (duo) {
      var duoInput = document.querySelector('[data-komua-offer][data-section="' + block.dataset.section + '"] input[value="duo"]');
      if (!duoInput) return;
      var dv = duoInput.dataset.variants.split(',').map(Number); var dp = duoInput.dataset.products.split(',').map(Number);
      dv.forEach(function (id, i) { lines.push({ id: id, product: dp[i], mode: 'unique' }); });
    } else if (offer && offer.dataset.offerType === 'quantity') {
      lines.push({ id: variantId, quantity: Number(offer.dataset.quantity), mode: 'target' });
    } else if (offer && offer.dataset.offerType === 'bundle') {
      lines.push({ id: variantId, product: product, mode: 'unique' });
      lines.push({ id: Number(offer.dataset.bundleVariant), product: Number(offer.dataset.bundleProduct), mode: 'unique' });
    } else {
      lines.push({ id: variantId, quantity: qty, mode: 'add' });
    }
    addons.forEach(function (a) { lines.push({ id: Number(a.dataset.addonVariant), product: Number(a.dataset.addonProduct), mode: 'unique' }); });
    event.preventDefault();
    event.stopImmediatePropagation();
    var label = btn.innerHTML;
    btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    btn.classList.add('loading');
    var err = block.querySelector('.komua-offers__error'); if (err) err.hidden = true;
    addLines(lines)
      .then(function () {
        [offer].concat(addons).forEach(function (i) { if (i) track('offer_add_to_cart', offerData(block, i)); });
      })
      .catch(function (e) { showError(block, e); })
      .then(function () { btn.innerHTML = label; btn.disabled = false; btn.removeAttribute('aria-busy'); btn.classList.remove('loading'); apply(block); });
  }, true);

  document.addEventListener('change', function (event) {
    var block = event.target.closest && event.target.closest('[data-komua-offers]');
    if (!block) return;
    apply(block);
    if (event.target.checked || event.target.type === 'checkbox') track('offer_select', Object.assign(offerData(block, event.target), { checked: !!event.target.checked }));
  });

  // ── Panier : boutons des recommandations ────────────────────────────────────────────────────────────────────────────
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-komua-offers-add]');
    if (!btn || btn.disabled) return;
    event.preventDefault();
    var label = btn.innerHTML;
    btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    if (btn.dataset.adding) btn.textContent = btn.dataset.adding;
    var items = [];
    try { items = JSON.parse(btn.dataset.komuaOffersAdd); } catch (e) {}
    var box = btn.closest('.komua-offers-cart');
    addLines(items.map(function (i) { return { id: i.id, quantity: i.quantity, mode: 'add' }; }))
      .then(function () {
        track('offer_add_to_cart', { offer_id: btn.dataset.offer, offer_type: btn.dataset.offerType, placement: 'cart', campaign: btn.dataset.campaign || '' });
        if (btn.dataset.campaign) track('campaign_click', { campaign: btn.dataset.campaign, placement: 'cart', offer_id: btn.dataset.offer });
      })
      .catch(function () {
        btn.innerHTML = label; btn.disabled = false; btn.removeAttribute('aria-busy');
        var el = box && box.querySelector('.komua-offers__error'); if (el) { el.textContent = el.dataset.error || ''; el.hidden = false; }
      });
  });

  // Offre activée dans le panier (réduction Shopify réellement appliquée) : une mesure par offre et par session.
  function completed() {
    document.querySelectorAll('[data-komua-offer-active]').forEach(function (el) {
      var id = el.dataset.komuaOfferActive; var key = 'komua-offer-completed:' + id;
      try { if (sessionStorage.getItem(key)) return; sessionStorage.setItem(key, '1'); } catch (e) {}
      track('offer_completed', { offer_id: id, offer_type: el.dataset.offerType, offer_saving: Number(el.dataset.saved || 0) / 100, currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || '' });
    });
  }

  // ── Campagnes et cartes d'offre ───────────────────────────────────────────────────────────────────────────────────────
  function expireCampaigns() {
    var now = Date.now() / 1000;
    document.querySelectorAll('[data-komua-campaign-end]').forEach(function (el) {
      if (Number(el.dataset.komuaCampaignEnd) && now > Number(el.dataset.komuaCampaignEnd)) el.hidden = true;
    });
    document.querySelectorAll('[data-komua-campaign-fallback]').forEach(function (el) {
      var bar = document.querySelector('.komua-campaign-bar');
      if (!bar || bar.hidden) el.hidden = false;
    });
  }
  function cardData(card) {
    var box = card.closest('[data-komua-cards]');
    return { offer_id: card.dataset.offer, offer_type: card.dataset.offerType, placement: card.dataset.placement, campaign: card.dataset.campaign || (box && box.dataset.campaign) || '', position: Number(card.dataset.position || 0), currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || '' };
  }
  var seen = typeof WeakSet === 'function' ? new WeakSet() : null;
  function once(el) { if (!seen) return true; if (seen.has(el)) return false; seen.add(el); return true; }
  function watch() {
    var cards = [].slice.call(document.querySelectorAll('[data-komua-card]'));
    var camps = [].slice.call(document.querySelectorAll('[data-komua-campaign]')).filter(function (el) { return !el.hidden; });
    var fire = function (el) {
      if (!once(el)) return;
      if (el.hasAttribute('data-komua-card')) track('offer_card_view', cardData(el));
      else track('campaign_view', { campaign: el.dataset.komuaCampaign, placement: el.dataset.placement || 'homepage' });
    };
    if (!('IntersectionObserver' in window)) { cards.concat(camps).forEach(fire); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { fire(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    cards.concat(camps).forEach(function (el) { if (!seen || !seen.has(el)) io.observe(el); });
  }
  document.addEventListener('click', function (event) {
    var card = event.target.closest && event.target.closest('[data-komua-card]');
    if (card) {
      var d = cardData(card); track('offer_card_click', d);
      if (d.campaign) track('campaign_click', { campaign: d.campaign, placement: d.placement, offer_id: d.offer_id });
      return;
    }
    var link = event.target.closest && event.target.closest('[data-komua-campaign-link]');
    var host = link && link.closest('[data-komua-campaign]');
    if (host) track('campaign_click', { campaign: host.dataset.komuaCampaign, placement: host.dataset.placement || '' });
  });
  // Offre demandée par l'URL (carte d'offre) : cochée une seule fois, à l'arrivée sur la fiche
  function fromUrl(block) {
    if (block.komuaFromUrl) return; block.komuaFromUrl = true;
    var want = ''; try { want = new URLSearchParams(window.location.search).get('komua_offer') || ''; } catch (e) {}
    if (!want) return;
    var input = [].slice.call(block.querySelectorAll('input[type="radio"], input[type="checkbox"]')).filter(function (i) { return i.value === want; })[0];
    if (input && !input.disabled) input.checked = true;
  }

  function init() {
    expireCampaigns();
    watch();
    document.querySelectorAll('[data-komua-offers]').forEach(function (block) {
      fromUrl(block);
      apply(block);
      if (block.komuaViewed) return;
      block.komuaViewed = true;
      block.querySelectorAll('input[data-offer]').forEach(function (i) { track('offer_view', offerData(block, i)); });
    });
    completed();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('pageshow', init);
  var d = drawer();
  if (d && window.MutationObserver) new MutationObserver(function () { clearTimeout(window.komuaOffersT); window.komuaOffersT = setTimeout(function () { completed(); watch(); }, 400); }).observe(d, { childList: true, subtree: true });
})();
